import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.24685 2.79092C0.755381 2.8742 0.42722 3.32459 0.513879 3.7969L0.984607 6.36244C1.00299 6.46264 1.03857 6.55578 1.08792 6.63955C1.05833 6.72544 1.04231 6.81726 1.04231 6.91268V14.7281C1.04231 16.1668 2.25599 17.3332 3.75313 17.3332H12.7892C14.2863 17.3332 15.5 16.1668 15.5 14.7281V6.91268C15.5 6.43309 15.0954 6.04431 14.5964 6.04431H8.06567L14.4897 4.95575C14.9811 4.87247 15.3093 4.42208 15.2226 3.94978L14.7519 1.38423C14.6653 0.911928 14.1966 0.596562 13.7051 0.679842L1.24685 2.79092ZM2.60745 5.20568L2.45054 4.35049L13.1291 2.541L13.286 3.39618L2.60745 5.20568ZM2.84952 7.78106V14.7281C2.84952 15.2076 3.25408 15.5964 3.75313 15.5964H12.7892C13.2882 15.5964 13.6928 15.2076 13.6928 14.7281V7.78106H10.0784V12.1229L8.27116 9.51781L6.46395 12.1229V7.78106H2.84952Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}